// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-smart-component {
  --height-smart-component-compact: 158px;
  --padding-component: 10px;
  --size-icon-main: 50px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  padding: var(--padding-component);
  background-color: white;
  min-height: var(--height-smart-component-compact);
}
.container-smart-component.supervision-view {
  --size-icon-main: 70px;
  --height-smart-component-compact: 70px;
  --padding-component: 0;
  height: -moz-fit-content;
  height: fit-content;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 200px;
  box-shadow: none;
  background-color: transparent;
}
.container-smart-component ion-button[disabled] {
  opacity: 1;
}
@media (max-width: 768px) {
  .container-smart-component:not(.supervision-view) {
    --height-smart-component-compact: 70px;
  }
  .container-smart-component:not(.supervision-view) ion-button, .container-smart-component:not(.supervision-view) .icon-and-text > img {
    width: 50px;
    height: 50px;
  }
  .container-smart-component:not(.supervision-view) .icon-and-text.up-orientation,
  .container-smart-component:not(.supervision-view) .icon-and-text.down-orientation {
    flex-direction: row;
    text-align: left;
    justify-content: flex-start;
  }
}
.container-smart-component .expanded {
  height: 100%;
}

.icon-and-text {
  display: flex;
  align-items: center;
  gap: 10px;
  height: calc(var(--height-smart-component-compact) - var(--padding-component) * 2);
}
.icon-and-text.right-orientation {
  flex-direction: row-reverse;
  text-align: right;
}
.icon-and-text.up-orientation {
  flex-direction: column;
  text-align: center;
  justify-content: center;
}
.icon-and-text.down-orientation {
  flex-direction: column-reverse;
  text-align: center;
  justify-content: center;
}

.title {
  font-size: 18px;
  font-weight: 600;
  margin-left: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  line-height: 1;
}

.supervision-view .title {
  font-size: 15px;
}

.container-spinner {
  height: calc(var(--height-smart-component-compact) - var(--padding-component) * 2);
  width: 100%;
}

ion-button {
  --border-radius: 24%;
  --padding-start: 0;
  --padding-end: 0;
  width: 70px;
  height: 70px;
  --box-shadow: 0;
  flex-shrink: 0;
}
ion-button.ion-activated {
  scale: 1.2;
}

img {
  width: 70px;
  height: 70px;
  object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/widget-label-button/widget-label-button.component.scss","webpack://./src/components/shared-components/styles/mixins.scss"],"names":[],"mappings":"AAEA;ECDI,uCAAA;EACA,yBAAA;EACA,sBAAA;EACA,iDAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,iCAAA;EACA,uBAAA;EACA,iDAAA;ADCJ;ACCI;EACI,sBAAA;EACA,sCAAA;EACA,sBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;ADCR;ACEI;EACI,UAAA;ADAR;AAlBI;EADF;IAEI,sCAAA;EAqBJ;EAnBI;IACE,WAAA;IACA,YAAA;EAqBN;EAjBI;;IAEE,mBAAA;IACA,gBAAA;IACA,2BAAA;EAmBN;AACF;AAfE;EACE,YAAA;AAiBJ;;AAbA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kFAAA;AAgBF;AAdE;EACE,2BAAA;EACA,iBAAA;AAgBJ;AAbE;EACE,sBAAA;EACA,kBAAA;EACA,uBAAA;AAeJ;AAZE;EACE,8BAAA;EACA,kBAAA;EACA,uBAAA;AAcJ;;AAVA;ECeI,eAAA;EACA,gBAAA;EDdF,cAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;AAcF;;AAXA;EACE,eAAA;AAcF;;AAXA;ECTI,kFAAA;EACA,WAAA;ADwBJ;;AAZA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAeF;AAbE;EACE,UAAA;AAeJ;;AAXA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAcF","sourcesContent":["@use \"../../styles/mixins\" as *;\n\n.container-smart-component {\n  @include external-apparance;\n\n  &:not(.supervision-view) {\n    @media (max-width: 768px) {\n      --height-smart-component-compact: 70px;\n\n      ion-button, .icon-and-text > img {\n        width: 50px;\n        height: 50px;\n      }\n\n      // On mobile the label always stays horizontal: up/down fall back to icon on the left\n      .icon-and-text.up-orientation,\n      .icon-and-text.down-orientation {\n        flex-direction: row;\n        text-align: left;\n        justify-content: flex-start;\n      }\n    }\n  }\n\n  .expanded {\n    height: 100%;\n  }\n}\n\n.icon-and-text {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  height: calc(var(--height-smart-component-compact) - (var(--padding-component) * 2));\n\n  &.right-orientation {\n    flex-direction: row-reverse;\n    text-align: right;\n  }\n\n  &.up-orientation {\n    flex-direction: column;\n    text-align: center;\n    justify-content: center;\n  }\n\n  &.down-orientation {\n    flex-direction: column-reverse;\n    text-align: center;\n    justify-content: center;\n  }\n}\n\n.title {\n  @include title-main;\n  margin-left: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  line-height: 1;\n}\n\n.supervision-view .title {\n  font-size: 15px;\n}\n\n.container-spinner {\n  @include container-spinenr;\n}\n\nion-button {\n  --border-radius: 24%;\n  --padding-start: 0;\n  --padding-end: 0;\n  width: 70px;\n  height: 70px;\n  --box-shadow: 0;\n  flex-shrink: 0;\n\n  &.ion-activated {\n    scale: 1.2;\n  }\n}\n\nimg {\n  width: 70px;\n  height: 70px;\n  object-fit: contain;\n}","@mixin external-apparance {\n    --height-smart-component-compact: 158px;\n    --padding-component: 10px;\n    --size-icon-main: 50px;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    border-radius: 15px;\n    display: flex;\n    flex-direction: column;\n    padding: var(--padding-component);\n    background-color: white;\n    min-height: var(--height-smart-component-compact);\n\n    &.supervision-view {\n        --size-icon-main: 70px;\n        --height-smart-component-compact: 70px;\n        --padding-component: 0;\n        height: fit-content;\n        width: fit-content;\n        max-width: 200px;\n        box-shadow: none;\n        background-color: transparent;\n    }\n\n    ion-button[disabled] {\n        opacity: 1;\n    }\n}\n\n@mixin icon-and-text {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    &.right-orientation {\n        flex-direction: row-reverse;\n        text-align: right;\n    }\n\n    &.up-orientation {\n        gap: 5px;\n        flex-direction: column;\n        text-align: center;\n        justify-content: center;\n\n        .title {\n            line-height: 2.1;\n        }\n    }\n\n    &.down-orientation {\n        flex-direction: column-reverse;\n        text-align: center;\n        justify-content: center;\n    }\n}\n\n@mixin container-spinenr {\n    height: calc(var(--height-smart-component-compact) - (var(--padding-component) * 2));\n    width: 100%;\n}\n\n@mixin icon-main {\n    width: var(--size-icon-main);\n    height: var(--size-icon-main);\n    flex-shrink: 0;\n}\n\n@mixin title-main {\n    font-size: 18px;\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
